export default __webpack_public_path__ + "static/media/onepunchman.a8babf1b.mp3";